export default __webpack_public_path__ + "b3bfcb0398329e72791e23363950c384.svg";